// @ts-strict-ignore
import { ArticleVO } from '@article/model/vo/article.vo';
import { OverlayBackground } from '@shared/overlay/overlay.type';
import { ComplexProjectVO } from '../model/vo/project.vo';
import { OverlayService } from '@shared/overlay/overlay.service';
import { ProjectDataService } from './project-data.service';
import { CompositeModelDataHolder } from '@3d-scene/model3d/cache/model-data';
import { CompositeArticleManager } from '@article/manager/composite-article.manager';
import { Injectable } from '@angular/core';
import { ProServeProjectImportProcessor } from '../components/import-export/processor/pro-serve-project-import.processor';

/**
 * @remarks
 * Do not use this service. Use CompositeArticleCacheManager instead.
 */
@Injectable({ providedIn: 'root' })
export class LoadArticleProjectService {
  constructor(
    private overlayService: OverlayService,
    private projectDataService: ProjectDataService,
    private compositeArticleManager: CompositeArticleManager,
    private proServeProjectImportProcessor: ProServeProjectImportProcessor
  ) {}

  public async loadCompositeArticleProject(articleVO: ArticleVO): Promise<CompositeModelDataHolder> {
    this.overlayService.requestOverlayShow(OverlayBackground.color);
    try {
      const complexProjectVO = await this.projectDataService.loadCompositeArticleComplexProjectByArticleId(articleVO.identity);
      this.loadCompositeConfigurationModel(articleVO, complexProjectVO);
      return new CompositeModelDataHolder(articleVO, complexProjectVO, null);
    } catch (error) {
      if (!await this.proServeProjectImportProcessor.connectArticle_failure()) {
        throw error;
      }
    } finally {
      this.overlayService.requestOverlayHide(OverlayBackground.color);
    }
  }

  public loadCompositeConfigurationModel(articleVO: ArticleVO, complexProjectVO: ComplexProjectVO): CompositeModelDataHolder {
    const compositeModelDataHolder = new CompositeModelDataHolder(articleVO, complexProjectVO, null);
    this.compositeArticleManager.parseCompositeModelHandler(compositeModelDataHolder);
    return compositeModelDataHolder;
  }
}
